import { api } from "../../services/api";
import { datosPurchase, marcarPurchase, purchaseYaInformado, rastrear } from "../../domain/metaPixel/metaPixel";

// informarCompra manda el Purchase al pixel del evento cuando la compra ya
// está aprobada. Recibe la referencia externa o { idcarrito }. Una vez por
// compra; si algo falla, la compra no se entera.
export const informarCompra = async (referencia) => {
  if (!referencia) return;
  try {
    const respuesta = await api.seguimiento.compra(referencia);
    const compra = respuesta?.data;
    const purchase = datosPurchase(compra);
    if (!purchase || purchaseYaInformado(compra.idcompra)) return;
    if (rastrear(purchase.pixel, "Purchase", purchase.datos, purchase.opciones)) {
      marcarPurchase(compra.idcompra);
    }
  } catch {
    // la medición nunca interrumpe la compra
  }
};
